var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"md12":"","sm12":"","lg12":""}},[_c('common-import-upload')],1),_c('v-flex',{attrs:{"md6":"","sm6":"","lg6":""}},[_c('common-import-list')],1),_c('v-flex',{attrs:{"md6":"","sm6":"","lg6":""}},[_c('common-import-edit')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }